import { useState, useEffect, useRef } from "react";
import { CookieCategories } from "types";

export const useCheckCookieConsent = (category: CookieCategories): boolean => {
  let timer = useRef<ReturnType<typeof setInterval>>(setInterval(() => {}));
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    const checkSocialCookiesAllowed = () => {
      if (window?.Cookiebot?.consent[category]) {
        setConsent(true);
      } else {
        setConsent(false);
      }
    };

    // Cookie loads async, consent is checked after 1sec
    setTimeout(checkSocialCookiesAllowed, 1000);
    timer.current = setInterval(checkSocialCookiesAllowed, 2500);

    return () => clearInterval(timer.current);
  }, [category, consent]);

  return consent;
};
